export enum AboutAkkoOptions {
  ABOUT_AKKO_DESTRIBUTOR_ID = '3',
  ABOUT_AKKO_OTHER_ID = '11',
}
